import translation from "../../../utils/translation";

const fetchPartnerWorkerListFulfilled = (state, action) => {
  state.status = 'succeeded';
  
  const payloadData = action?.payload?.data;
  const partnerData = payloadData?.data?.data || [];
  const paginationInfo = payloadData?.data || {};
  
  if (partnerData.length > 0) {
    state.partnerWorkers = partnerData;
    state.currentPage = paginationInfo.current_page || 1; 
    state.perPage = paginationInfo.per_page || 10; 
    state.totalPages = paginationInfo.last_page || 0; 
    state.totalPartnerWorkers = paginationInfo.total || 0; 
    state.lastUpdated = payloadData.last_update || null;
    state.message = payloadData.message || ''; 
  } else {
    state.partnerWorkers = []; 
    state.currentPage = 1; 
    state.perPage = 10; 
    state.totalPages = 0; 
    state.totalPartnerWorkers = 0; 
    state.lastUpdated = null; 
    state.message = translation('key_no_data_available'); 
  }
};

const partnerWorkerProfileStatusesFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.workerProfileStatuses = action?.payload?.data;
}

const handleAddWorkerBioDataFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.savedWorker = action.payload.data;
};

const handleEditPartnerWorkerBioDataFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.savedWorker = action.payload.data;
}

const handleSaveWorkerProcessingDataFulfilled = (state) => {
  state.status = 'succeeded';
};

const handlePartnerSendRegLinkFulfilled = (state) => {
  state.status = 'succeeded';
};

const handlePartnerWorkerStatusFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.partnerWorkerStatus = action.payload.data || [];
}

const handlePartnerWorkerChangeStatusFulfilled = (state) => {
  state.status = 'succeeded';
}

export {
  fetchPartnerWorkerListFulfilled,
  handleAddWorkerBioDataFulfilled,
  handleSaveWorkerProcessingDataFulfilled,
  partnerWorkerProfileStatusesFulfilled,
  handlePartnerSendRegLinkFulfilled,
  handleEditPartnerWorkerBioDataFulfilled,
  handlePartnerWorkerStatusFulfilled,
  handlePartnerWorkerChangeStatusFulfilled
};